// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"d2-z","dimensionLabel":"e2-z","styleChooserControlWrapper":"f2-z","styleChooserControl":"g2-z","disabled":"h2-z","giftCard":"i2-z","styleChooserText":"j2-z"};